import React, { useState, useEffect, useRef, useContext } from "react";
import { Container, Row, Col,Label, NavLink  } from "reactstrap";
import ReactToPrint from "react-to-print-advanced";
import {Decimal} from 'decimal.js';
import CloseIcon from '@mui/icons-material/Close';
import { NavLink as RRNavLink, Outlet } from "react-router-dom";
import StoreContext from "./../Store/Context";
import { CLOSE_IMAGE } from "../Image";
import { validate } from 'react-email-validator';
import {CotizacionModal } from "./../Modal";
import {IconButton } from "@mui/material";
import { FIND_DESC } from "./../Util";
import LocalPrintshopIcon from "@mui/icons-material/LocalPrintshop";
import {ComponentToPrintsCotizacion} from "../../Inventario/ComponentToPrintss";
import {STATES_COT_COTIZACION} from "../States";
import {DATATABLE_COTIZACION} from "../Datatables"
import {get_re_retencion, get_gr_garantia,delete_cotd_cotizacion_detail,post_cotd_cotizacion_detail_row,put_cot_cotizacion_encabezado,put_cot_cotizacion_sts,
  get_articulo_by_code,get_cli_cliente, get_list_items, post_cli_cliente, put_cli_cliente,put_cotd_cotizacion_detalle_row, get_cotd_cotizacion_detail, 
  post_cot_cotizacion, get_all_cotizacion } from "../Services";

export const Cotizacion = () => {
  var componentRef = useRef();
  const { dataCompania,usr_id,usr_sucursal,usr_precio,compania,usr_key_login,quitToken} = useContext(StoreContext);
  const [dataGarantia, setDataGarantia] = useState([]);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);
  const [isPrinting, setPrintI] = useState(false);
  const [isTabAddClientes, setTabAddClientes] = useState(false);
  const [isSaveI, setSaveI] = useState(false);
  const [error_upc, setError_upc] = useState("");
  const [dataCliente, setDataCliente] = useState([]);
  const [dataCotizacion, setDataCotizacion] = useState([]);
  const [dataItems, setDataItems] = useState([]);
  const [basicModal, setBasicModal] = useState(false);
  const [basicModalEdit, setBasicModalEdit] = useState(false);
  const [OBJCotizacionDetalle, setOBJCotizacionDetalle] = useState([]);
  // const [formCompania, setFormCompania] = useState(STATES_COT_COTIZACION({staneName:"formCompania"}));
  const [formCotCotizacion, setFormCotCotizacion] = useState(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
  const [formCotCotizacionDetalle, setFormCotCotizacionDetalle] = useState(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
  const [formClientes, setFormClientes] = useState(STATES_COT_COTIZACION({staneName:"formClientes"}));
  const [formPrecio, setFormPrecio] = useState(STATES_COT_COTIZACION({staneName:"formPrecio"}));
  const [dataRetencion, setDataRetencion] = useState([]);

  async function fetch_cot_cotizacion() {
    var response = await get_all_cotizacion({usr_sucursal});
    setDataCotizacion(response);
  }
  
  async function fetchReRetencion() {
    var response = await get_re_retencion();
    setDataRetencion(response);
  }
  
  async function post_cotd_cotizacion_detail({body}) {
    var response = post_cotd_cotizacion_detail_row(body);
    response.then((data) => {
      setError("");
      if(data===true)
        fetchCotdDetalle(body.cotd_identificador)
      else
        setError("ERROR "+data);
    });
  }

  async function put_cotd_cotizacion_detail_({body}) {
    var result = put_cotd_cotizacion_detalle_row(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetchCotdDetalle(body.cotd_identificador)
      else
        setError("ERROR "+data);
    });
  }

  async function fetchGarantia() {
    var response = await get_gr_garantia();
    setDataGarantia(response);
  }

  async function fetchCliente() {
    var response = await get_cli_cliente();
    setDataCliente(response);
  }

  async function fetch_list_items() {
    var response = await get_list_items();
    setDataItems(response);
  }

  async function fetchArticuloByUpc(art_upc) {
    var response = await get_articulo_by_code(art_upc);
    if (response[0] !== undefined) {
      setFormPrecio({
        art_precio:response[0].art_precio,
        art_precio2:response[0].art_precio2,
        art_precio3:response[0].art_precio3,
      })
      setError_upc("");
      setFormCotCotizacionDetalle({
        ...formCotCotizacionDetalle,
        cotd_articulo: response[0].art_id,
        art_descripcion: response[0].art_descripcion,
        art_upc: response[0].art_upc,
        cotd_precio: response[0].art_precio,
        art_itbm_cod_v: response[0].art_itbm_cod_v,
        art_itbm_venta:response[0].art_itbm_venta,
        cotd_cantidad:"1",
        art_imgName:response[0].art_imgName,
        art_img:response[0].art_img,
        art_referencia:response[0].art_referencia,
      });
    } else {
      setError_upc("Articulo no existe");
    }
  }

  useEffect(() => {
    fetchCliente();
    fetch_list_items();
    fetch_cot_cotizacion();
    if(dataCompania.count ==="0"){
      quitToken()
    }
    fetchGarantia();
    fetchReRetencion();
  }, []);

  const selectCliente = (row) => {
    setFormClientes({
      ...formClientes,
      cli_id: row.original.cli_id,
      cli_nombre: row.original.cli_nombre,
      cli_ruc: row.original.cli_ruc,
      cli_email: row.original.cli_email,
      cli_dv: row.original.cli_dv
    });
    setError("");
  };

  const onClickDeleteCotizacion_sts = ({ cot_id, cot_status }) => {
    var body = {
      cot_id,
      cot_status,
    };

    var result = put_cot_cotizacion_sts(body);
    result.then((data) => {
      setError("");
      if(data===true)
        fetch_cot_cotizacion();
      else
        setError("ERROR "+data);
    });
  };
  
  function onChangeCot_CotizacionDetalle(event) {
    const { value, name } = event.target;
    setFormCotCotizacionDetalle({
      ...formCotCotizacionDetalle,
      art_descripcion: name === "art_upc" ? "" : formCotCotizacionDetalle.art_descripcion,
      cotd_precio: name === "art_upc" ? "" : formCotCotizacionDetalle.cotd_precio,
      cotd_cantidad: name === "art_upc" ? "" : formCotCotizacionDetalle.cotd_cantidad,
      art_referencia: name === "art_upc" ? "" : formCotCotizacionDetalle.art_referencia,
      [name]: value,
    });

    setError("");
    setError_upc("");
  }

  const deleteRow = (row) => {
    var value = OBJCotizacionDetalle.filter((data, i) => {
      if (i !== row.index) return data;
    });
    setOBJCotizacionDetalle(value);
    if(basicModalEdit){
      var body ={
        cotd_id:row.original.cotd_id
      }
      delete_cotd_cotizacion_detail(body)
    }
  };

  const onBlurF = (event, row) => {
    var data = OBJCotizacionDetalle.filter((datos, i) => {
      if (i !== row.index) {
        return datos;
      }
    });
    setOBJCotizacionDetalle((OBJCotizacionDetalle) => [
      ...data,
      ...[
        {
          art_descripcion: row.original.art_descripcion,
          cotd_cantidad: event.target.value,
          cotd_itbms: row.original.cotd_itbms,
          cotd_precio: row.original.cotd_precio,
          cotd_total: row.original.cotd_total,
          cotd_articulo: row.original.cotd_articulo,
        },
      ],
    ]);
  };

  function handleKeyPress(event) { 
    const { value, name } = event.target;
    if (event.key === "Enter" && name === "art_upc") {
      fetchArticuloByUpc(value);
    }
    if (event.key === "Enter" && name === "cotd_cantidad" || event.key ===undefined) {
      var flag = false;
      var itbms=0;
      var total =0;
      var cantidad =0;
      var cotd_id ="";
      var objItems = OBJCotizacionDetalle.map((data, i) => {
        if (data.cotd_articulo === formCotCotizacionDetalle.cotd_articulo && data.art_descripcion === formCotCotizacionDetalle.art_descripcion) {
          cantidad = Number(data.cotd_cantidad) + Number(formCotCotizacionDetalle.cotd_cantidad);
          itbms = (new Decimal(cantidad).times(new Decimal(data.cotd_precio))).times(new Decimal(data.art_itbm_venta));
          
          // cantidad = (Number(data.cotd_cantidad) + Number(formCotCotizacionDetalle.cotd_cantidad)).toFixed(2);
          // itbms = ((Number(cantidad)*Number(data.cotd_precio))*Number(data.art_itbm_venta)).toFixed(4);
          total = ((Number(cantidad)*Number(data.cotd_precio)) + Number(itbms)).toFixed(4);
          flag = true;
          data.cotd_cantidad = Number(cantidad).toFixed(2);
          data.cotd_itbms =  new Decimal(itbms).toDecimalPlaces(2,Decimal.ROUND_UP);;
          data.cotd_total = (new Decimal(cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP);
          cotd_id = data.cotd_id;
        }
        return data;
      });
      if (!flag) {
        itbms = (new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).times(new Decimal(formCotCotizacionDetalle.art_itbm_venta));
        // itbms = ((Number(formCotCotizacionDetalle.cotd_cantidad)*Number(formCotCotizacionDetalle.cotd_precio))*Number(formCotCotizacionDetalle.art_itbm_venta)).toFixed(4);
        total = ((Number(formCotCotizacionDetalle.cotd_cantidad)*Number(formCotCotizacionDetalle.cotd_precio))+(Number(itbms))).toFixed(4);
        setOBJCotizacionDetalle([...OBJCotizacionDetalle, ...[{...formCotCotizacionDetalle,
          cotd_itbms:new Decimal(itbms).toDecimalPlaces(2,Decimal.ROUND_UP),
          cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP),
        }]]);
        if(basicModalEdit){
          var body ={
            cotd_identificador: formCotCotizacion.cot_identificador,
            cotd_sucursal:usr_sucursal,
            cotd_articulo: formCotCotizacionDetalle.cotd_articulo,
            cotd_cantidad: formCotCotizacionDetalle.cotd_cantidad,
            cotd_descuento: formCotCotizacionDetalle.cotd_descuento,
            cotd_descuento_number: formCotCotizacionDetalle.cotd_descuento_number,
            cotd_precio: formCotCotizacionDetalle.cotd_precio,
            cotd_itbms:new Decimal(itbms).toDecimalPlaces(2,Decimal.ROUND_UP),
            cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP),
            cotd_art_descripcion:formCotCotizacionDetalle.art_descripcion,
          }
          post_cotd_cotizacion_detail({body})
        }

      } else {
        setOBJCotizacionDetalle(objItems);
        if(basicModalEdit){
          var body ={
            cotd_id:cotd_id,
            cotd_identificador: formCotCotizacion.cot_identificador,
            cotd_articulo: formCotCotizacionDetalle.cotd_articulo,
            cotd_cantidad: cantidad,
            cotd_descuento: formCotCotizacionDetalle.cotd_descuento,
            cotd_descuento_number: formCotCotizacionDetalle.cotd_descuento_number,
            cotd_precio: formCotCotizacionDetalle.cotd_precio,
            cotd_itbms:new Decimal(itbms).toDecimalPlaces(2,Decimal.ROUND_UP),
            cotd_total:(new Decimal(formCotCotizacionDetalle.cotd_cantidad).times(new Decimal(formCotCotizacionDetalle.cotd_precio))).plus(new Decimal(itbms)).toDecimalPlaces(2,Decimal.ROUND_UP),
            cotd_art_descripcion:formCotCotizacionDetalle.art_descripcion,
          }
          put_cotd_cotizacion_detail_({body})
        }
      }
      setFormCotCotizacionDetalle(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
    }
    setError("");
  }

  const onClickNuevaCotizacion = () => {
    setBasicModalEdit(false)
    setBasicModal(true);
    setOBJCotizacionDetalle([]);
    setFormCotCotizacionDetalle(STATES_COT_COTIZACION({staneName:"formCotCotizacionDetalle"}));
    setFormCotCotizacion(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
     setFormClientes(STATES_COT_COTIZACION({staneName:"formClientes"}))
  };


  const onClickSaveCotizacion = () => {
    setLoading(true);
    if (OBJCotizacionDetalle[0] !== undefined) {
      var dataCOT_detail = OBJCotizacionDetalle.map((val, i) => {
        return {
          cotd_identificador: formCotCotizacion.cot_identificador,
          cotd_articulo: val.cotd_articulo,
          cotd_art_descripcion:val.art_descripcion,
          cotd_precio: val.cotd_precio,
          cotd_cantidad: val.cotd_cantidad,
          cotd_itbms: Number(val.cotd_itbms).toFixed(4),
          cotd_descuento: val.cotd_descuento,
          cotd_total: Number(val.cotd_total).toFixed(4),
          cotd_descuento_number: val.cotd_descuento_number,
          cotd_sucursal:usr_sucursal
        };
      });

      var body = {
        formCotCotizacion: {
          cot_identificador: formCotCotizacion.cot_identificador,
          cot_cliente: formClientes.cli_id,
          cot_fecha: formCotCotizacion.cot_fecha,
          cot_vendedor: usr_id,
          cot_descripcion: formCotCotizacion.cot_descripcion,
          cot_garantia:formCotCotizacion.cot_garantia,
          cot_garantia_name:formCotCotizacion.cot_garantia_name,
          cot_sucursal:usr_sucursal
        },
        dataCotizacionDetalle: dataCOT_detail,
      };


      var result = post_cot_cotizacion(body);
      result.then((data) => {
        setError("");
        if(data===true)
        {
          setSaveI(false);
          setBasicModal(false);
          fetch_cot_cotizacion();
          setLoading(false)
        }
        else
          setError("ERROR "+data);
      });

    } else {
      setError("Campos vacios");
    }
  };

  const toggleSaveEncabezado = () => {
    var body = {
      cot_garantia:formCotCotizacion.cot_garantia,
      cot_garantia_name:formCotCotizacion.cot_garantia_name,
      cot_fecha:formCotCotizacion.cot_fecha,
      cot_id:formCotCotizacion.cot_id,
      cot_descripcion:formCotCotizacion.cot_descripcion
    };
    put_cot_cotizacion_encabezado(body)
  };
  
  function onChangeCliente(event) {
    const { value, name } = event.target;
    setFormClientes({
      ...formClientes,
      [name]: value,
    });
    setError("");
  }

  function onChange(event) {
    const { value, name } = event.target;
    setFormCotCotizacion({
      ...formCotCotizacion,
      [name]: value,
    });
    setError("");
  }

  const onClickSaveCliente = () => {
    setLoading(true)
    var body = {
      cli_nombre: formClientes.cli_nombre,
      cli_direccion: formClientes.cli_direccion,
      cli_telefono: formClientes.cli_telefono,
      cli_telefono2: formClientes.cli_telefono2,
      cli_ruc: formClientes.cli_ruc.trim(),
      cli_dv: formClientes.cli_dv,
      cli_email: formClientes.cli_email,
      cli_limitc: formClientes.cli_limitc,
      cli_credito:formClientes.cli_credito,
      cli_retencion:formClientes.re_id,
      return:false
    };
    if (formClientes.cli_nombre.length > 0) {
      if(formClientes.cli_email.length>0){
        if(validate(formClientes.cli_email)){
          if(FIND_DESC(dataCliente,formClientes.cli_ruc,null)){
            setError("Error: Ruc ya esta registrado");
          }
          else{

            // var result = post_cli_cliente(body);
            // result.then((data) => {
            //   setError("");
            //   if(data===true)
            //   {
               
            //   }
            //   else
            //     setError("ERROR "+data);
            // });

            var result =   post_cli_cliente(body);
            result.then((data) => {
              setFormClientes({...formClientes,cli_id:data});
            });
            setTimeout(() => {
              fetchCliente();
              setTabAddClientes(false)
              setLoading(false)
            }, 1000);
          }
        }
        else{
          setError("E-Mail incorrecto");
        }
      }
      else{
        if(FIND_DESC(dataCliente,formClientes.cli_ruc,null)){
          setError("Error: Ruc ya esta registrado");
        }
        else{
            var result =   post_cli_cliente(body);
            result.then((data) => {
              setFormClientes({...formClientes,cli_id:data});
            });
            setTimeout(() => {
              fetchCliente();
              setTabAddClientes(false)
              setLoading(false)
            }, 1000);
        }
      }

    } else {
      setError("Campos importantes estan vacios");
    }
  };

  function setFormClientesBlank(){
    setFormClientes(STATES_COT_COTIZACION({staneName:"formClientes"}))
  }
  async function fetchCotdDetalle(cot_identificador) {
    var response;
    response = await get_cotd_cotizacion_detail(cot_identificador);
    setOBJCotizacionDetalle(response);
  }

  const update_cotd_cotizacion_detalle_row = (values, cotd_identificador) => {
    var result = put_cotd_cotizacion_detalle_row(values);
    result.then((data) => {
      setError("");
      if(data===true)
      {
        fetchCotdDetalle(cotd_identificador)
      }
      else
        setError("ERROR "+data);
    });
  };

  const onClickUpdateClient = ({cli_id, cli_nombre,cli_direccion,cli_telefono2,  cli_ruc,cli_dv,cli_telefono,cli_email,cli_limitc,cli_credito,cli_retencion}) => {
    setLoading(true)
    var body = {
      cli_id,
      cli_nombre,
      cli_direccion,
      cli_telefono,
      cli_telefono2,
      cli_ruc,
      cli_dv,
      cli_email,
      cli_limitc,
      cli_credito,
      cli_retencion
    };
    if (cli_nombre.length > 0) {
      var result = put_cli_cliente(body);
      result.then((data) => {
        setError("");
        if(data===true)
        {
          fetchCliente();
          setLoading(false);
        }
        else
          setError("ERROR "+data);
      });
    } else {
      setError("Campos importantes estan vacios");
    }
  };

  async function fetchArticuloByUpcRe(art_upc) {
    var response;
    response = await get_articulo_by_code(art_upc);
    if (response[0] !== undefined) {
      setFormPrecio({
        art_precio:response[0].art_precio,
        art_precio2:response[0].art_precio2,
        art_precio3:response[0].art_precio3,
      })
      setError_upc("");
      setFormCotCotizacionDetalle({
        ...formCotCotizacionDetalle,
        cotd_articulo:response[0].art_id,
        cotd_cantidad: "1",
        art_upc: response[0].art_upc,
        art_descripcion: response[0].art_descripcion,
        cotd_precio:response[0].art_precio,
        art_itbm_cod_v:response[0].art_itbm_cod_v,
        art_itbm_venta:response[0].art_itbm_venta,
        art_imgName:response[0].art_imgName,
        art_img:response[0].art_img,
        art_referencia:response[0].art_referencia,
      });
    } else {
      setError_upc("Articulo no existe");
    }
  }
  
  var ObjClientes = [];
  dataCliente.map((item) => {
    ObjClientes.push({
      value: item.cli_id,
      label: item.cli_nombre + " " + item.cli_ruc,
      ruc: item.cli_ruc,
      email: item.cli_email,
      dv: item.cli_dv,
      objName: "cliente",
    });
  });

  var enableTab = true;
  if (formClientes.cli_id.length > 0) {
    enableTab = false;
  }

  function setPrecio(art_precio) {
    setFormCotCotizacionDetalle({
      ...formCotCotizacionDetalle,
      cotd_precio: art_precio,
    }); 
  };
  const handleOnChangeCheckBox = (event) => {
    const { value, name } = event.target;
    setFormClientes({
      ...formClientes,
      [name]:value==="0"?"1":"0"
  })
  };
  return (
    <Container className="bg-light border" fluid>
      {basicModal && (
        <CotizacionModal
          formCotizacion={formCotCotizacion}
          isOpen={basicModal}
          toggle={setBasicModal}
          onChange={onChange}
          error={error}
          error_upc={error_upc}
          basicModalEdit={basicModalEdit}
          OBJCotizacionDetalle={OBJCotizacionDetalle}
          formCotCotizacionDetalle={formCotCotizacionDetalle}
          propsDropdown={ObjClientes}
          toggleSave={onClickSaveCotizacion}
          onChangeCot_detail={onChangeCot_CotizacionDetalle}
          handleKeyPress={handleKeyPress}
          onBlurs={onBlurF}
          isSaveI={isSaveI}
          deleteRow={deleteRow}
          setOBJCotizacionDetalle={setOBJCotizacionDetalle}
          fetch_cot_cotizacion={fetch_cot_cotizacion}
          update_cotd_cotizacion_detalle_row={update_cotd_cotizacion_detalle_row}
          toggleSaveEncabezado={toggleSaveEncabezado}
          selectCliente={selectCliente}
          dataCliente={dataCliente}
          formClientes={formClientes}
          onChangeCliente={onChangeCliente}
          setFormClientesBlank={setFormClientesBlank}
          onClickSaveCliente={onClickSaveCliente}
          selectItem={fetchArticuloByUpcRe}
          dataItems={dataItems}
          isTabAddClientes={isTabAddClientes}
          setTabAddClientes = {setTabAddClientes}
          setFormClientes={setFormClientes}
          setError={setError}
          onClickUpdateClient={onClickUpdateClient}
          usr_precio={usr_precio}
          setPrecio={setPrecio}
          formPrecio={formPrecio}
          handleOnChangeCheckBox={handleOnChangeCheckBox}
          loading={loading}
          dataGarantia={dataGarantia}
          formCotCotizacion={formCotCotizacion}
          dataRetencion={dataRetencion}
          setFormCotCotizacion={setFormCotCotizacion}
        />
      )}
      <Row className="mt-2">
        <Col xs={10} className="text-center">
          <Label className="font-weight-bold-title">COTIZACIÓN</Label>
        </Col>
        <Col xs={2} className="text-end">
          <NavLink tag={RRNavLink} to="/user/home" className="font-w-bold   menu-l-c">
            <img src={CLOSE_IMAGE} className="src-image-x" alt="..."/>
          </NavLink>
        </Col>
        {isPrinting ? (
          <React.Fragment>
            <Col xs={9}></Col>
              <Col xs={3} className="d-flex" >
                <IconButton className="float-right-btn"
                  onClick={() => {
                    setPrintI(false);
                    setFormCotCotizacion(STATES_COT_COTIZACION({staneName:"formCotCotizacion"}));
                    setOBJCotizacionDetalle([]);
                  }}>
                  <CloseIcon />
                </IconButton>
                <ReactToPrint
                  trigger={() => <button className="btn-print">  <IconButton className="float-right-btn"><LocalPrintshopIcon /></IconButton></button>}
                  content={() => componentRef} />
              </Col>
              <Col xs={12} className="text-center scrol-table2 padding-v-20">
                <ComponentToPrintsCotizacion
                  ref={el => (componentRef = el)}
                  props={OBJCotizacionDetalle}
                  dataCompania={dataCompania}
                  form={formCotCotizacion}
                />
              </Col>
          </React.Fragment>
          ) :(
            <Col xs={12} className="modal-add-inventario datatable-factura">
              <DATATABLE_COTIZACION dataCotizacion={dataCotizacion} onClickDeleteCotizacion_sts={onClickDeleteCotizacion_sts} setBasicModalEdit={setBasicModalEdit} 
              setBasicModal={setBasicModal} setFormCotCotizacion={setFormCotCotizacion} fetchCotdDetalle={fetchCotdDetalle} 
              setFormClientesBlank={setFormClientesBlank} setFormClientes={setFormClientes} setPrintI={setPrintI} onClickNuevaCotizacion={onClickNuevaCotizacion} fetch_cot_cotizacion={fetch_cot_cotizacion}/>
          </Col>
          )}

      </Row>
    </Container>
  );
};
